import * as React from "react";
import type { SVGProps } from "react";
const SvgDollarSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.75 3.001v1.25M7.75 13v-1.25M10.237 6a1.87 1.87 0 0 0-1.862-1.75h-1.37a1.755 1.755 0 0 0-.427 3.458l2.343.588a1.755 1.755 0 0 1-.427 3.458h-1.37A1.87 1.87 0 0 1 5.261 10"
    />
  </svg>
);
export default SvgDollarSimple;
